import React from 'react'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'

import DateInput from './DateInput'
import DatePickerIconButton from './DatePickerIconButton'

import theme from './Schedule.scss'

class Schedule extends React.Component {
  render() {
    const {
      label,
      input,
      onInputChange,
      onDateChange,
      dateInput,
      error,
      disabled
    } = this.props

    return (
      <Flex styleName='container'>
        <div styleName='iconWrapper'>
          <DatePickerIconButton
            label={label}
            value={dateInput}
            onChange={onDateChange}
            disabled={disabled}
          />
        </div>
        <div styleName='inputField'>
          <DateInput
            error={error}
            label={label}
            value={input}
            onChange={onInputChange}
            disabled={disabled}
          />
        </div>
      </Flex>
    )
  }
}

export default CSSModules(Schedule, theme)
